import React, { useEffect, useState } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../helpers/form/FormHelper'
import MyButton from '../../UI/form/MyButton'
import { formDataProductIsField, formDataProductRequiredField } from '../../../helpers/form/FormData'
import PackFormOrderId from './fields/PackFormOrderId'
import { checkPackAPI, createPackAPI } from '../../../api/pack/packAPI'
import { responseError } from '../../../helpers/response/ResponseHelper'
import PackResult from './result/PackResult'

const PackForm = () => {

    const [data, setData] = useState({}) // Дані з форми
    
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const check = () => {
        setError('')
        setResult('')
        setLoading(true)
        checkPackAPI({
            keyCrmOrderNumber: data.orderId
        }).then(data => {
            setResult(data)
            setLoading(false)
		}).catch(e => {
            setError(responseError(e))
            setLoading(false)
		})
    }

  return (
    <div className='loginPage__form-inputs'>
        {
            !result ?
                formDataProductIsField('orderId', 'pack') ?
                    <PackFormOrderId
                        required={formDataProductRequiredField('orderId', 'pack')}
                        setValidate={e => updateValidate(setValid, 'orderId', e)}
                        setValueForm={e => setValueForm(setData, 'orderId', e)}
                        forciblyValue={data && data.orderId ? data.orderId : ''}
                    />
                : ''
            : ''
        }        

        {
			error ?
				<div className='error'>
					{ error }
				</div>
			: ''
		}
        {
            result ? 
                <PackResult 
                    orderIdCrm={data.orderId}
                    resultCheck={result}
                />
            :
                <MyButton
                    size='md'
                    onClick={check}
                    disabled={!isValidForm || loading ? true : false}
                >
                    Отримати дані з замовлення
                </MyButton>
        }
    </div>
  )
}

export default PackForm